package org.vreo.devicehub.features.userAuthentication.data.mappers

import org.vreo.devicehub.features.userAuthentication.data.dto.UserDetailsDto
import org.vreo.devicehub.features.userAuthentication.domain.User
import org.vreo.devicehub.features.userAuthentication.domain.UserRole

/**
 * Map [UserDetailsDto] to [User]
 *
 * @return user
 */
fun UserDetailsDto.toUser(): User {
    val role = this.role ?: UserRole.USER.value

    return User(
        email = email,
        firstName = firstName,
        lastName = lastName,
        mobileNumber = mobileNumber,
        role = role,
        companyName = companyName,
        companyAddressStreet = companyAddressStreet,
        companyAddressCity = companyAddressCity,
        companyAddressPostalCode = companyAddressPostalCode,
        companyAddressCountry = companyAddressCountry
    )
}

/**
 * Map [User] to [UserDetailsDto].
 *
 * @return user details
 */
fun User.toUserDetailsDto(): UserDetailsDto {
    return UserDetailsDto(
        email = email,
        password = password?: "",
        firstName = firstName,
        lastName = lastName,
        mobileNumber = mobileNumber,
        role = role,
        companyName = companyName,
        companyAddressStreet = companyAddressStreet,
        companyAddressCity = companyAddressCity,
        companyAddressPostalCode = companyAddressPostalCode,
        companyAddressCountry = companyAddressCountry,
    )
}
